module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_7005.132a487f.png";